import { createSlice, createAsyncThunk, PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../../utils/config";
import { toast } from "react-toastify";

const { apiEndpoint, apiUrl } = config;
const accessToken = sessionStorage.getItem("us_st_d");

interface CoreState {
    loading?: boolean,
    data?: any,
    error?: any
};

const initialState: CoreState = {
    loading: false,
    data: '',
    error: ''
}

// Turn backend validation codes into a readable sentence
const humanizeValidation = (raw?: string): string => {
    if (!raw) return "";
    return String(raw)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((code) => {
            switch (code) {
                case "validation.unique": return "a seller with this email already exists";
                case "validation.required": return "some required fields are missing";
                case "validation.email": return "the email address is invalid";
                default: return code;
            }
        })
        .join("; ");
};

// Build the best possible error message from the /seller_register response body
const buildRegisterErrorMessage = (data: any): string => {
    const nested = Array.isArray(data?.error) ? data.error[0] : data?.error;
    const detail = humanizeValidation(nested?.message);
    const base = data?.message || "Something went wrong while registering the seller";
    return detail ? `${base} — ${detail}` : base;
};

const errorToastOpts = {
    position: "top-right" as const,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

export const registerSeller = createAsyncThunk('seller/register', async (_data: any) => {
    try {
        // console.log("accessTokenaccessToken", accessToken);

        const { data } = await axios({
            url: `${apiEndpoint}/seller_register`,
            method: "POST",
            headers: {
                "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
            },
            data: [_data]
        });
        const { status } = data;
        // console.log("asyy", data);

        if (status === 200) {
            toast.success("New seller registered !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return true;
        } else {
            toast.error(buildRegisterErrorMessage(data), errorToastOpts);
            return false;
        }
    } catch (error: any) {
        toast.error(buildRegisterErrorMessage(error?.response?.data), errorToastOpts);
        return false;
    }
})

const sellerSlice = createSlice({
    name: 'seller',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(registerSeller.pending, (state, action) => {
            state.loading = true;
            state.data = '';
            state.error = '';

        })
        builder.addCase(registerSeller.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = '';
        })
        builder.addCase(registerSeller.rejected, (state, action) => {
            state.loading = false;
            state.data = '';
            state.error = 'error';
        })
    }
})


export default sellerSlice.reducer;